/* import __COLOCATED_TEMPLATE__ from './fa-badge-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();